import React, { Component } from 'react'
import styled from 'styled-components'
import VectorLayer from 'ol/layer/Vector'
import { Vector as VectorSource } from 'ol/source'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { useTable, useBlockLayout, useResizeColumns } from 'react-table'
import { useSticky } from 'react-table-sticky'
import { CSVLink } from 'react-csv'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark'
import { extend as olExtentExtend } from 'ol/extent' // Na importovanie funkcie pre rozšírenie extentu
import * as helpers from './helpers'
import * as vHelpers from './vHelpers'
import './AttributeTableTabs.scss'

const mainConfig = window.config

class AttributeTableTabs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCheckboxEnabled: true,
      areAllChecked: false,
      areAllCheckedPerTable: {}, // Uchová stav zapnutia checkboxov pre každý tab
      checkedFeatures: {},
      itemLength: 0
    }
    this.tableRef = React.createRef()

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this)
    this.onAddToMapChange = this.onAddToMapChange.bind(this)

    this.vectorSourceHighlight = new VectorSource()
    this.vectorLayerHighlight = new VectorLayer({
      source: this.vectorSourceHighlight,
      zIndex: 4,
      style: function (feature) {
        let geometryType = feature.getGeometry().getType()
        let strokeColor =
          geometryType === 'LineString' || geometryType === 'MultiLineString'
            ? [255, 255, 0, 0.8]
            : [0, 0, 0, 1]
        let strokeWidth =
          geometryType === 'LineString' || geometryType === 'MultiLineString'
            ? 7
            : 1

        return new Style({
          fill: new Fill({ color: [255, 255, 0, 0.8] }),
          stroke: new Stroke({ color: strokeColor, width: strokeWidth }),
          image: new CircleStyle({
            radius: 5,
            fill: new Fill({ color: [255, 255, 0, 0.8] }),
            stroke: new Stroke({ color: strokeColor, width: strokeWidth })
          })
        })
      }
    })
  }

  componentDidMount() {
    if (window.map) {
      window.map.addLayer(this.vectorLayerHighlight) // Pridáme vrstvu do mapy, keď je komponent pripojený a `window.map` je inicializovaná
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.itemLength !== this.props.items[0]?.geoJson.length) {
      this.setState(
        {
          itemLength: this.props.items[0]?.geoJson.length
        },
        () => {
          // Resetovanie stavu checkboxu "Pridať do mapy"
          const tabName = this.props.items[0]?.name // Názov aktuálneho tabu
          if (tabName) {
            this.setState((prevState) => ({
              areAllCheckedPerTable: {
                ...prevState.areAllCheckedPerTable,
                [tabName]: false // Zruší sa checkbox pre daný tab
              }
            }))
          }
        }
      )
    }

    // Ak sa zmenil počet tabov alebo názvy tabov, resetujeme stav checkboxov
    if (
      prevProps.items.length !== this.props.items.length ||
      prevProps.items.some(
        (item, idx) => item.name !== this.props.items[idx].name
      )
    ) {
      this.resetCheckboxesForTabs()
    }
  }

  resetCheckboxesForTabs() {
    const { items } = this.props
    const { checkedFeatures, areAllCheckedPerTable } = this.state

    // Najprv odstránime všetky aktuálne vykreslené vrstvy z mapy
    items.forEach((item) => {
      const normalizedLayerName = `${item.name}-layer`
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const layersBeforeRemoval = window.map.getLayers().getArray()

      layersBeforeRemoval.forEach((layer) => {
        const currentLayerName = layer.get('name')
        const normalizedCurrentLayerName = currentLayerName
          ? currentLayerName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          : ''

        if (
          normalizedCurrentLayerName &&
          normalizedCurrentLayerName.includes(normalizedLayerName)
        ) {
          window.map.removeLayer(layer)
        }
      })
    })

    // Teraz prejdeme cez každý tab a znovu vykreslíme aktívne vrstvy a checkboxy
    items.forEach((item) => {
      const isLayerActive = areAllCheckedPerTable[item.name] || false
      const activeCheckboxes = checkedFeatures[item.name] || {}

      // if (isLayerActive) {
      //   // Znovu vykreslíme vrstvu pre celý tab, ak je "Pridať do mapy" aktívne
      //   // vHelpers.renderFeature(item, 'filter', true)
      // }

      // // Vykreslíme jednotlivé funkcie na základe stavu zapnutých checkboxov
      // Object.keys(activeCheckboxes).forEach((rowIndex) => {
      //   if (activeCheckboxes[rowIndex]) {
      //     // const feature = item.geoJson[rowIndex]
      //     // const uniqueLayerName = `${item.name}-checkbox-${rowIndex}`
      //     console.log('render3')
      //     // window.emitter.emit(
      //     //   'renderFeature',
      //     //   feature,
      //     //   item.layerName,
      //     //   item.name,
      //     //   uniqueLayerName,
      //     //   uniqueLayerName,
      //     //   true,
      //     //   null
      //     //   // 'rgb(255, 0, 0, 0.7)'
      //     // )
      //   }
      // })
    })

    // Obnovíme stav checkboxov podľa aktuálneho nastavenia
    this.setState({
      checkedFeatures: { ...checkedFeatures },
      areAllCheckedPerTable: { ...areAllCheckedPerTable }
    })
  }

  onAddToMapChange(isChecked, tabName) {
    console.log('onAddToMapChange')

    const { items } = this.props
    const activeItem = items.find((item) => item.name === tabName)
    if (!activeItem) {
      console.warn('No active item found for the specified tab.')
      return
    }

    const features = activeItem.geoJson // Používame geoJson pre všetky riadky

    if (!features || features.length === 0) {
      console.warn('No features found for the specified tab.')
      return
    }

    let updatedCheckedFeatures = {}
    let combinedExtent = null

    // window.emitter.emit("removeRenderedFeature", "bothByLayerName", activeItem.name);

    // Nastavenie checkboxov na základe stavu `isChecked`
    features.forEach((feature, rowIndex) => {
      if (!feature || !feature.getGeometry()) {
        console.warn('Skipped invalid feature.')
        return
      }

      updatedCheckedFeatures[rowIndex] = isChecked // Nastavíme všetky checkboxy

      const isRowCheckedBefore = this.state.checkedFeatures[tabName]?.[rowIndex]

      if (isChecked) {
        if (!isRowCheckedBefore || isRowCheckedBefore === undefined) {
          // Získanie extentu geometrie
          const featureExtent = feature.getGeometry().getExtent()
          combinedExtent = combinedExtent
            ? olExtentExtend(combinedExtent, featureExtent)
            : featureExtent.slice()

          // Pridanie geometrie do mapy
          const uniqueLayerName = `${tabName}-checkbox-${rowIndex}`

          window.emitter.emit(
            'renderFeature',
            feature,
            activeItem.layerName,
            activeItem.name,
            uniqueLayerName,
            uniqueLayerName,
            true,
            null
            // 'rgb(255, 0, 0, 0.7)' // Štýl geometrie
          )
        }
      }
    })

    if (!isChecked) {
      // Odstránime všetky geometrie z mapy
      window.emitter.emit(
        'removeRenderedFeature',
        'bothByLayerName',
        activeItem.name
      )
    }

    // Ak všetky geometrie pridávame do mapy, nastavíme nový extent
    if (isChecked && combinedExtent) {
      window.map.getView().fit(combinedExtent, { duration: 1000, maxZoom: 18 })
    }

    // Aktualizujeme stav checkboxov
    this.setState(
      (prevState) => ({
        areAllCheckedPerTable: {
          ...prevState.areAllCheckedPerTable,
          [tabName]: isChecked
        },
        checkedFeatures: {
          ...prevState.checkedFeatures,
          [tabName]: updatedCheckedFeatures
        }
      }),
      () => {
        this.forceUpdate() // Aktualizácia UI
      }
    )
  }

  renderTabLayers = (item) => {
    const isFromURI = item.layerSource === 'uri'
    const isFromKN = item.layerSource === 'kn'

    if (!item.geoJson || item.geoJson.length === 0) return

    // Vymažeme existujúce checkbox vrstvy
    const layers = window.map.getLayers().getArray()
    layers.forEach((layer) => {
      const layerName = layer.get('name')
      if (layerName && layerName.includes('checkbox')) {
        window.map.removeLayer(layer) // Odstráni vrstvu z mapy
      }
    })

    window.emitter.emit('removeRenderedFeature', 'bothBySource', null, 'filter')
    window.emitter.emit('removeRenderedFeature', 'bothBySource', null, 'uri')
    window.emitter.emit('removeRenderedFeature', 'bothBySource', null, 'kn')
    window.emitter.emit('removeRenderedFeature', 'allHighlights')
    window.emitter.emit('removeRenderedFeature', 'checkbox-layer')
    window.emitter.emit('closePopup')

    if (isFromURI) {
      window.emitter.emit(
        'renderFeature',
        item.geoJson,
        item.tabName,
        item.tabName,
        item.geoJson[0].ol_uid,
        'uri',
        true
      )
    } else if (isFromKN) {
      window.emitter.emit(
        'renderFeature',
        item.geoJson,
        item.tabName,
        item.tabName,
        item.id,
        item.layerSource,
        true
      )
    } else {
      // vHelpers.renderFeature(item, 'filter', true)
    }
  }

  // Metóda calcNewZoom
  calcNewZoom(zoomValue) {
    let newZoom;

    if (zoomValue > 4 && zoomValue <= 13) {
      newZoom = zoomValue - 1;
    } else if (zoomValue > 13 && zoomValue <= 14) {
      newZoom = zoomValue - 2;
    } else if (zoomValue > 14 && zoomValue <= 16) {
      newZoom = zoomValue - 3;
    } else if (zoomValue > 16 && zoomValue <= 17) {
      newZoom = zoomValue - 3;
    } else if (zoomValue > 17) {
      newZoom = zoomValue - 8;
    } else {
      newZoom = zoomValue - 0.5;
    }

    if (newZoom > 11) {
      newZoom = 11;
    }

    return newZoom;
  }

  handleCheckboxClick(evt, item, rowIndex) {
    evt.stopPropagation()

    const ref = this.tableRef.current
    if (!ref) {
      console.warn('Referencia na tabuľku nie je dostupná.')
      return
    }
    
    const feature = item.geoJson[rowIndex]

    const uniqueLayerName = `${item.name}-checkbox-${rowIndex}`
    const rowLayerName = `${item.name}-uid-${item.layerName}.${rowIndex + 1}`
    const rowLayerName_parcels = `${item.name}-uid-${feature.id_}`

    const row_id = item.layerName === undefined ? rowLayerName_parcels : rowLayerName

    // const rowLayerName_parcels = `${item.name}-uid-${item.layerSource}_${rowIndex + 1}`
    const tabName = item.name

    if (!feature || !feature.getGeometry) {
      console.warn('Feature nemá geometriu. Kliknutie je zakázané.')
      return
    }

    const isChecked = evt.target.checked

    if (isChecked) {
      // Pridanie funkcie do mapy
      window.emitter.emit(
        'renderFeature',
        feature,
        item.layerName,
        item.name,
        uniqueLayerName,
        uniqueLayerName,
        true,
        null
        // 'rgb(255, 0, 0, 0.7)'
      )

      // Zoom na geometriu
      const geometry = feature.getGeometry()
      if (geometry) {
        const extent = geometry.getExtent();
        const view = window.map.getView();
  
        // Fit view to extent
        view.fit(extent, {
          duration: 1000,
          maxZoom: 18,
        });
  
        // Vypočítanie nového zoomu
        const zoomValue = view.getZoom();
        const newZoom = this.calcNewZoom(zoomValue);
  
        // Nastavenie nového zoomu
        view.setZoom(newZoom);
      }
    } else {
      // Odstránenie funkcie z mapy
      window.emitter.emit(
        'removeRenderedFeature',
        'bothByLayerName',
        uniqueLayerName
      )
    }

    this.setState(
      (prevState) => ({
        checkedFeatures: {
          ...prevState.checkedFeatures,
          [item.name]: {
            ...prevState.checkedFeatures[item.name],
            [rowIndex]: isChecked
          }
        }
      }),
      () => {
        const elem = document.getElementById(row_id) 
        const container = document.getElementById(
          'sc-attribute-table-tab-' + tabName
        )

        if (elem !== null && container !== null) {
          const tabRow = elem.getElementsByClassName('td')
          let index_r = tabRow.length

          while (index_r--) {
            tabRow[index_r].className = 'td highlight-row'
          }

          const scrollPosition = elem.offsetTop - container.offsetTop - 7

          setTimeout(() => {
            container.scrollTo({ top: scrollPosition, behavior: 'smooth' })
            if (container.scrollTop !== scrollPosition) {
              console.warn(
                'Scrollovanie nebolo úspešné, skúša sa manuálne nastavenie.'
              )
              container.scrollTop = scrollPosition
            }
          }, 100) // Optimalizovaný čas na DOM aktualizáciu
        }
        // this.forceUpdate();
      }
    )
  } 

  // Metóda na resetovanie stavov checkboxov
  resetCheckboxStates = () => {
    this.setState({
      areAllChecked: false,
      areAllCheckedPerTable: {},
      checkedFeatures: {},
    });
  };

  // Metóda na vymazanie checkboxov pre konkrétny tab
  clearCheckboxStatesForTab = (tabName) => {
    console.log("Before clearing checkbox states:", this.state.checkedFeatures);
  
    this.setState((prevState) => {
      const newCheckedFeatures = { ...prevState.checkedFeatures };
      delete newCheckedFeatures[tabName]; // Odstránenie stavu pre konkrétny tab
      return { checkedFeatures: newCheckedFeatures };
    }, () => {
      // Callback po aktualizácii stavu
      // console.log("After clearing checkbox states:", this.state.checkedFeatures);
      // console.log(`Checkbox states for tab '${tabName}' cleared.`);
    });
  };
  

  render() {
    if (this.props.items.length === 0)
      return <div>Žiadne informácie na zobrazenie.</div>
    return (
      <div>
        <Tabs
          forceRenderTabPanel={true}
          selectedIndex={this.props.tabIndex}
          onSelect={(e) => {
            this.props.onTabClick(e, false)
          }}
        >
          <TabList>
            {this.props.items.map((item) => {
              return (
                <Tab
                  id={item.name}
                  key={helpers.getUID()}
                  className="sc-attribute-table-tab sc-noselect"
                >
                  <AttributeTableTabButton
                    key={helpers.getUID()}
                    name={item.name}
                    alias={item.alias}
                    onTabClose={this.props.onTabClose}
                  />
                </Tab>
              )
            })}
          </TabList>
          {this.props.items.map((item) => {
            return (
              <TabPanel
                id={item.name + '_content'}
                key={helpers.getUID()}
              >
                <AttributeTableContent
                  item={item}
                  data={item.geoJson}
                  key={helpers.getUID()}
                  height={this.props.height}
                  width={this.props.width}
                  onHeaderClick={this.props.onHeaderClick}
                  onRowClick={this.props.onRowClick}
                  onLoadMoreClick={this.props.onLoadMoreClick}
                  onLoadAllClick={this.props.onLoadAllClick}
                  name={item.name}
                  isLoading={this.props.isLoading}
                  handleCheckboxClick={this.handleCheckboxClick}
                  isCheckboxEnabled={this.state.isCheckboxEnabled}
                  onAddToMapChange={this.onAddToMapChange}
                  areAllChecked={this.state.areAllChecked}
                  tabIndex={this.props.tabIndex}
                  checkedFeatures={this.state.checkedFeatures[item.name] || {}}
                  areAllCheckedPerTable={this.state.areAllCheckedPerTable}
                  tableRef={this.tableRef}
                />
              </TabPanel>
            )
          })}
        </Tabs>
      </div>
    )
  }
}

export default AttributeTableTabs

// TAB BUTTON
const AttributeTableTabButton = (props) => {
  const handlePreventClick = (e, name) => {
    e.stopPropagation()
    const tabName = props.alias ? props.alias : props.name
    props.onTabClose(tabName)
  }
  return (
    <div>
      {props.alias ? props.alias : props.name}
      <div
        className="sc-attribute-table-close-button-container"
        onClick={(e) => handlePreventClick(e, props.name)}
      >
        <FontAwesomeIcon
          className="faCircleXmark-tabs-icon"
          icon={faXmark}
        />
      </div>
    </div>
  )
}

// TAB CONTENT
const AttributeTableContent = (props) => {
  if (props.data.length === 0) return <div>No Data</div>

  const tabName = props.item.alias ? props.item.alias : props.name
  const tmpData = {}

  // CREATE COLUMNS
  let columnArray = []

  if (props.isCheckboxEnabled) {
    columnArray.unshift({
      // Použijeme `unshift`, aby sme zabezpečili, že stĺpec bude prvý
      Header: '*',
      accessor: 'select',
      Cell: ({ row }) => (
        <div className="checkbox-cell">
          <input type="checkbox" />
        </div>
      ),
      width: 26, // Nastavte požadovanú šírku stĺpca tu
      style: { backgroundColor: '#f8f8f8' }
    })
  }

  const attFromConfig =
    mainConfig.layerAttributesForPopup[props.item['layerName']] ||
    mainConfig.layerAttributesForPopup[props.item['layerSource']] ||
    mainConfig.layerAttributesForPopup[props.item['layername']]

  let attArray = []
  if (attFromConfig !== undefined) {
    attFromConfig.forEach((att) => {
      attArray.push(att.field)
    })
  }

  let data = props.data[0]

  if (!data) {
    data = helpers.getFeatureFromGeoJSON(props.item.geoJson.values_.geom)
    data.values_ = props.data.values_
  }

  Object.keys(data.getProperties()).forEach((key) => {
    const skipKeys = [
      'geometry',
      'orig_geom_name',
      'vfid',
      'geom',
      'Affiliation_Code',
      'Affiliation_Id',
      'Affiliation_Name',
      'CadastralUnit_Code',
      'CadastralUnit_Id',
      'Folio_CadastralUnit_Code',
      'Folio_CadastralUnit_Id',
      'Folio_CadastralUnit_Name',
      'Folio_Id',
      'Id',
      'LandUse_Code',
      'LandUse_Id',
      'Localization_Code',
      'Localization_Id',
      'Localization_Name',
      'OwnershipType_Code',
      'OwnershipType_Id',
      'OwnershipType_Name',
      'PROTECTED_PROPERTIES_NAME_LIST',
      'SharedProperty_Code',
      'SharedProperty_Id',
      'SharedProperty_Name',
      'Utilisation_Code',
      'Utilisation_Id',
      'ValidTo'
    ]

    if (skipKeys.includes(key)) return
    const originKey = key
    if (attFromConfig !== undefined) {
      if (!attArray.includes(key)) {
        return
      } else {
        attFromConfig.forEach((att) => {
          if (att['field'] === key) key = att['alias']
        })
      }
    }

    columnArray.push({
      Header: key,
      accessor: key,
      visible: false,
      originKey: originKey
    })
  })

  tmpData['columns'] = columnArray

  let csvData = []
  let rowArray = []
  let jsonArray = []

  let features = Array.isArray(props.item.geoJson)
    ? props.item.geoJson
    : [props.item.geoJson]

  features.forEach((feature) => {
    let id = feature.id_
    if (id === undefined) {
      id = feature.ol_uid
    }

    if (id.includes('fid--')) {
      id = feature.values_.vfid
    }
    const featureProps = feature.getProperties()

    let row = {}
    // row["*"] = "";

    Object.keys(featureProps).forEach((key) => {
      let colName = key
      if (
        key === 'geometry' ||
        key === 'orig_geom_name' ||
        key === 'vfid' ||
        key === 'geom'
      )
        return

      if (attFromConfig !== undefined) {
        if (!attArray.includes(key)) {
          return
        } else {
          attFromConfig.forEach((att) => {
            if (att.field === key) {
              colName = att.alias
            }
          })
        }
      }

      let val = featureProps[key]

      if (typeof val === 'boolean') {
        val = val ? 'áno' : 'nie'
      } else if (val === null || val === undefined || val === 'Null') {
        val = '-'
      }

      row[colName] = val
      row['idd'] = [tabName, id].join('-uid-')
    })

    let new_row = {}
    for (let [key, value] of Object.entries(row)) {
      if (key !== 'idd') {
        new_row[key] = value
      }
    }
    csvData.push(new_row)
    rowArray.push(row)
    jsonArray.push(feature)
  })

  tmpData['rows'] = rowArray
  window.jsonArray = jsonArray
  window.csvData = csvData

  const orderMap = {}

  if (Array.isArray(attFromConfig)) {
    attFromConfig.forEach((config, index) => {
      orderMap[config.field] = index
    })
    tmpData.columns.sort((a, b) => {
      // Pridáme kontrolu, aby stĺpec `*` zostal vždy na prvom mieste
      if (a.Header === '*') return -1
      if (b.Header === '*') return 1

      const orderA =
        orderMap[a.originKey] !== undefined ? orderMap[a.originKey] : 9999
      const orderB =
        orderMap[b.originKey] !== undefined ? orderMap[b.originKey] : 9999
      return orderA - orderB
    })
  }

  return (
    <div
      className="sc-attribute-table"
      id="sc-attribute-table"
    >
      <CustomTable
        columns={tmpData.columns}
        data={tmpData.rows}
        width={props.width}
        height={props.height}
        onHeaderClick={props.onHeaderClick}
        onRowClick={props.onRowClick}
        item={props.item}
        geoJsonLength={props.item.geoJson.length}
        onLoadMoreClick={props.onLoadMoreClick}
        onLoadAllClick={props.onLoadAllClick}
        isLoading={props.isLoading}
        handleCheckboxClick={props.handleCheckboxClick}
        isCheckboxEnabled={props.isCheckboxEnabled}
        areAllChecked={props.areAllChecked}
        onAddToMapChange={props.onAddToMapChange}
        tabIndex={props.tabIndex}
        checkedFeatures={props.checkedFeatures}
        areAllCheckedPerTable={props.areAllCheckedPerTable}
        tableRef={props.tableRef}
      />
    </div>
  )
}

const CustomTable = ({
  columns,
  data,
  width,
  height,
  onHeaderClick,
  item,
  geoJsonLength,
  onLoadMoreClick,
  onLoadAllClick,
  isLoading,
  onRowClick,
  handleCheckboxClick,
  isCheckboxEnabled,
  areAllChecked,
  onAddToMapChange,
  tabIndex,
  checkedFeatures,
  areAllCheckedPerTable,
  tableRef
}) => {
  const total = item.total <= item.geoJson.length ? item.geoJson.length : item.total 

  const id = item.alias
    ? 'sc-attribute-table-tab-' + item.alias
    : 'sc-attribute-table-tab-' + item.name

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data
      },
      useBlockLayout,
      useSticky,
      useResizeColumns
    )

  return (
    <Styles>
      <div
        {...getTableProps()}
        ref={tableRef} // Priradenie referencie
        className="table sticky sc-attribute-table-header-content"
        id={id}
        style={{
          width: width - 4,
          height: height - 30,
          backgroundColor: '#white'
        }}
        onScroll={(evt) => {
          const el = evt.target
          const triggerHeight = el.scrollHeight - el.offsetHeight
          item.scrollTop = el.scrollTop
          if (el.scrollTop > triggerHeight && item.maxRecords <= item.total) {
            onLoadMoreClick(item)
          }
        }}
      >
        <div className="header">
          {headerGroups.map((headerGroup) => {
            item.headerWidth = headerGroup.getHeaderGroupProps().style.width
            return (
              <div
                {...headerGroup.getHeaderGroupProps()}
                className="tr"
              >
                {headerGroup.headers.map((column) => (
                  <div
                    {...column.getHeaderProps()}
                    className="th sc-attribute-table-header"
                    onClick={(evt) => {
                      onHeaderClick(evt, item.name, column, item.layerSource)
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: column.render('Header')
                      }}
                    />
                    <div
                      {...column.getResizerProps()}
                      className={`resizer ${
                        column.isResizing ? 'isResizing' : ''
                      }`}
                    />
                  </div>
                ))}
              </div>
            )
          })}
        </div>
        <div
          {...getTableBodyProps()}
          className="body sc-attribute-table-row-content"
        >
          {rows.map((row) => {
            prepareRow(row)
            return (
              <div
                {...row.getRowProps()}
                className="tr"
                id={row.original.idd}
              >
                {row.cells.map((cell) => {
                  const isValidURL = (url) => {
                    try {
                      new URL(url, window.location.href)
                      console.log('url IS VALID', url)
                      if (url.length === 0) {
                        return false
                      }
                      console.log(typeof url, url.length)
                      return true
                    } catch (e) {
                      console.log('url IS NOT VALID', url)
                      return false
                    }
                  }

                  return (
                    <div
                      {...cell.getCellProps()}
                      className={
                        cell.column.Header === '*'
                          ? 'sc-attribute-table-cell-button td'
                          : 'td'
                      }
                      onClick={(evt) => {
                        if (cell.column.Header === '*') {
                          evt.stopPropagation() // Zastaví propagáciu eventu
                          // const checkbox = evt.target

                          // const uniqueLayerName = `${item.name}-checkbox-${row.index}`
                          // const layers = window.map.getLayers().getArray()
                          // const existingLayer = layers.find(
                          //   (layer) => layer.get('name') === uniqueLayerName
                          // )

                          // if (checkbox.checked) {
                          //   if (existingLayer) {
                          //     if (!existingLayer.getVisible()) {
                          //       // Ak vrstva existuje a je skrytá, zapneme ju
                          //       console.log(`Zapínam viditeľnosť pre vrstvu: ${uniqueLayerName}`);
                          //       existingLayer.setVisible(true);
                          //     } else {
                          //       console.log(`Vrstva "${uniqueLayerName}" už je viditeľná.`);
                          //     }
                          //   } else {
                          //     // Ak vrstva neexistuje, pridáme ju do mapy
                          //     console.log(`Pridávam novú vrstvu: ${uniqueLayerName}`);
                          //     handleCheckboxClick(evt, item, row.index, uniqueLayerName);
                          //   }
                          // } else {
                          //   if (existingLayer) {
                          //     // Ak vrstva existuje, skryjeme ju
                          //     console.log(`Vypínam viditeľnosť pre vrstvu: ${uniqueLayerName}`);
                          //     existingLayer.setVisible(false);
                          //   } else {
                          //     console.warn(`Vrstva s názvom "${uniqueLayerName}" nebola nájdená.`);
                          //   }
                          // }
                        } else if (
                          cell.column.Header !== 'Výpis z LV' &&
                          cell.column.Header !== 'Čiastočný výpis z LV' &&
                          cell.column.Header !== 'Obrázok'
                        ) {
                          onRowClick(evt, item, row.index)
                        } else {
                          console.log('cell.value', cell.value)
                        }
                      }}
                    >
                      {cell.column.Header === '*' ? (
                        isCheckboxEnabled ? (
                          <input
                            type="checkbox"
                            checked={checkedFeatures?.[row.index] || false} // Synchronizujeme stav podľa checkedFeatures
                            onChange={(evt) =>
                              handleCheckboxClick(evt, item, row.index)
                            }
                          />
                        ) : null
                      ) : typeof cell.value === 'boolean' ? (
                        cell.value ? (
                          'true'
                        ) : (
                          'false'
                        )
                      ) : cell.column.Header === 'Výpis z LV' ||
                        cell.column.Header === 'Čiastočný výpis z LV' ? (
                          cell.value && cell.value !== '-' ? (
                            <a
                            href={`${mainConfig.apiUrlEsprit}kataster/pdf/${cell.value}`}
                            target="_blank" // Otvorí odkaz v novej karte
                            rel="noopener noreferrer" // Zabezpečenie pre nové karty
                            onClick={(e) => {
                              e.stopPropagation(); // Zamedzí propagácii kliknutia
                            }}
                          >
                            Otvoriť
                          </a>
                          ) : (
                            '-'
                          )
                      ) : cell.column.Header === 'Obrázok' ? (
                        isValidURL(cell.value) ? (
                          <a
                            href={cell.value}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Otvoriť obrázok
                          </a>
                        ) : (
                          'Chybný alebo chýbajúci odkaz'
                        )
                      ) : (
                        cell.render('Cell')
                      )}
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
        <div
          className="footer"
          style={{
            width: item.headerWidth.replace('px', '') - 0,
            fontSize: '0.9rem',
            height: '33px'
          }}
        >
          {'Počet záznamov: ' +
            item.geoJson.length +
            ' z ' +
            (total || item.geoJson.length)}{' '}
            {/* (item.total || item.geoJson.length)}{' '} */}
          <div className="tab-footer-buttons">
            <>
              <button
                className="sc-button sc-attribute-table-footer-button"
                onClick={() => {
                  onLoadMoreClick(item)
                }}
                disabled={item.total <= 200}
              >
                Načítať viac
              </button>
              <button
                className="sc-button sc-attribute-table-footer-button"
                onClick={() => {
                  onLoadAllClick(item)
                }}
                disabled={item.total <= 200}
              >
                Načítať všetko
              </button>
            </>
            <CSVLink
              className="sc-button sc-attribute-table-footer-button csvLink"
              filename={item.name + '.csv'}
              data={window.csvData}
            >
              Stiahnuť tabuľku
            </CSVLink>

            <label className="sc-checkbox-label">
              <input
                type="checkbox"
                className="sc-checkbox"
                checked={areAllCheckedPerTable[item.name] || false} // Použitie názvu tabuľky
                onChange={(e) => onAddToMapChange(e.target.checked, item.name)}
              />
              Pridať do mapy
            </label>
          </div>
          <div
            className={isLoading ? 'sc-attribute-table-loading' : 'sc-hidden'}
          >
            <span>Načítava sa...</span>
            <img
              src={images['loading20.gif']}
              alt="loading"
              style={{ position: 'relative', top: '8px', marginLeft: '8px' }}
            />
          </div>
        </div>
      </div>
    </Styles>
  )
}

//style={{ width: document.getElementById(id) === null ? 400 : (parseInt(document.getElementById(id).offsetWidth) - 20) } }
//className="sc-attribute-table-footer"
// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg|gif)$/)
)
function importAllImages(r) {
  let images = {}
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)))
  return images
}

const Styles = styled.div`
  .table {
    border: 1px solid #ddd;

    .tr:hover {
      font-weight: 700;
    }
    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
    }

    .th,
    .td {
      padding: 5px;
      border-bottom: 1px solid #ddd;
      border-right: 1px solid #ddd;
      background-color: #fff;
      overflow: hidden;

      :last-child {
        border-right: 0;
      }

      .resizer {
        display: inline-block;
        width: 5px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;

        &.isResizing {
          background: red;
        }
      }
    }

    &.sticky {
      overflow: scroll;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }

      .header {
        top: 0;
        box-shadow: 0px 3px 3px #ccc;
      }

      .footer {
        bottom: 0;
      }

      .body {
        position: relative;
        z-index: 0;
      }

      [data-sticky-td] {
        position: sticky;
      }

      [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px #ccc;
      }

      [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px #ccc;
      }
    }
  }

  .checkbox-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`